import { CapoPlugin } from "/codebuild/output/src2808178616/src/web-front-end/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];